import { render } from "./InvoiceSettingList.vue?vue&type=template&id=263b852e"
import script from "./InvoiceSettingList.vue?vue&type=script&lang=js"
export * from "./InvoiceSettingList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__